module.exports = __webpack_public_path__ + "static/img/t1-5-2.84b42e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-5-2.png
// module id = YwcN
// module chunks = 1